/*
 * View showing the table listing of entries for a config group
 */

// noinspection JSUnusedLocalSymbols
define([
  "marionette",
  "jquery",
  "underscore",
  "highcharts/highcharts",
  "messaging/messenger",
  "bootstrapDatePicker",
  "modules/reportSplit/reports/configArea/template/configurationTemplate.html",
  "modules/reportSplit/reports/reportArea/dataModel",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "jspdf",
  "svg2pdf.js",
  "highcharts/modules/exporting",
  "highcharts/modules/offline-exporting",
  "moment-timezone",
], function (
  Marionette,
  $,
  _,
  Highcharts,
  Messenger,
  _DatePicker,
  configurationTemplate,
  _DataModel,
  ReportUtilities,
  jspdf,
  svg2pdf,
  HighchartsExporting,
  HighchartsOfflineExporting,
  Moment,
) {
  "use strict";

  // Hack to allow Highcharts Offline Export to find jsPDF and svg2pdf
  window.jspdf = jspdf;
  window.svg2pdf = svg2pdf;
  if (typeof HighchartsExporting === "function") {
    HighchartsExporting(Highcharts);
  }
  if (typeof HighchartsOfflineExporting === "function") {
    HighchartsOfflineExporting(Highcharts);
  }

  const ConfigAreaView = {};

  ConfigAreaView.configurationView = Marionette.ItemView.extend({
    template: configurationTemplate,
    onRender: function () {
      let taskResults;
      let taskSearchInput;
      let taskSourceFunction;
      let topicResults;
      let topicSourceFunction;
      let _this = this;

      this.$el.i18n();
      this.trigger("format:datepicker");

      //type-ahead-ize the typeaheads
      if (this.model.get("showSnippet")) {
        this._createSnippetSelect();
      }

      if (this.model.get("showTopic")) {
        topicSourceFunction = (query, process) => {
          topicResults = Messenger.reqres.request("topicsWithId:typeahead", query);
          topicResults.once("sync", () => {
            process(topicResults.map((result) => result.get("text")));
          });
        };

        let searchEl = this.$el.find("#txtSearch");
        if (this.model.get("optionalTopic")) {
          searchEl.prop("placeholder", $.t("reports.placeholder.optional.topic"));
        } else {
          searchEl.prop("placeholder", $.t("reports.placeholder.required.topic"));
        }
        searchEl.typeahead(
          {
            source: topicSourceFunction,
            updater: (item) => {
              let topicResult = topicResults.findWhere({ text: item });
              if (topicResult) {
                // Must wait, otherwise the closing of the typeahead will overwrite the value
                setTimeout(() => {
                  this.model.set("topic", topicResult.get("id"));
                  this.model.set("selectedTopicName", topicResult.get("text"));
                  this.$el.find("#txtSearch").val(topicResult.get("text"));
                }, 100);
                return topicResult.get("text");
              } else {
                this.model.set("topic", null);
                this.model.set("selectedTopicName", "");
              }
            },
          },
          this,
        );
      }
      if (this.model.get("showTask")) {
        taskSourceFunction = function (query, process) {
          taskResults = Messenger.reqres.request("tasks:typeahead", query);
          taskResults.once("sync", function () {
            process(
              taskResults.map(function (result) {
                return result.get("text");
              }),
            );
          });
        };
        taskSearchInput = $(".task-search-input", this.$el);
        taskSearchInput.prop("placeholder", $.t("reports.placeholder.optional.task"));
        taskSearchInput.typeahead({
          source: taskSourceFunction,
          updater: function (item) {
            const taskResult = taskResults.findWhere({ text: item });
            if (taskResult) {
              // Must wait, otherwise the closing of the typeahead will overwrite the value
              setTimeout(function () {
                _this.model.set("selectedTask", taskResult.get("id"));
                _this.model.set("selectedTaskName", taskResult.get("text"));
                taskSearchInput.val(taskResult.get("text"));
              }, 100);
            } else {
              _this.model.set("selectedTask", null);
              _this.model.set("selectedTaskName", "");
            }
          },
        });
      }
      // Make multi-select selects easier to use
      $("#topicStatusChoices", this.$el).select2({
        placeholder: $.t("reports.placeholder.optional.topicOrResponseStatuses"),
      });
      $("#topicScheduledStatusChoices", this.$el).select2({
        placeholder: $.t("reports.placeholder.optional.topicScheduledStatuses"),
      });
      $("#touchpointChoices", this.$el).select2({
        allowClear: this.model.get("optionalTouchpoints"),
        placeholder: $.t("reports.placeholder.optional.touchpoints"),
      });
      $("#siteChoices", this.$el).select2();
      $("#agentChoices", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.agents"),
      });
      $(".departments", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.departments"),
      });
      $(".task-owners", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.taskOwners"),
      });
      $(".users", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.users"),
      });
      $(".task-priorities", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.taskPriorities"),
      });
      $(".task-change-types", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.taskChangeTypes"),
      });
      $(".topic-edit-statuses", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.topicEditStatuses"),
      });
      $(".analytics-tags", this.$el).select2({
        allowClear: true,
        placeholder: $.t("reports.placeholder.optional.analyticsTags"),
      });
      const el = $("#languageChoices", this.$el);
      if (el.prop("multiple")) {
        el.select2({
          allowClear: this.model.get("optionalLanguages"),
          placeholder: $.t("reports.placeholder.optional.languages"),
        });
      }
    },
    events: {
      "click #btnDisplay": "updateConfig",
      "click #btnHide": "hide",
      "change #selCategories": "categoryChange",
      "change #categoryValues": "categoryValueChange",
      "change #standardResponseChoice": "standardResponseChange",
      "click #touchpointChoices": "touchpointClick",
      "change #intervals": "intervalClick",
      "change #startDate": "startDateClick",
      "change #endDate": "endDateClick",
      "click .optionAll": "clickAll",
      "click .optionNotAll": "clickNotAll",
      "click #chkAbbreviated": "clickAbbreviated",
      "click #chkFinished": "clickFinished",
      "click #btnPrint": "printAll",
      "change #txtSearch": "checkSearchEmpty",
      "change .task-search-input": "checkTaskSearchEmpty",
    },
    modelEvents: {
      "change:analyticsTags": "render",
      "change:departments": "render",
      "change:users": "render",
      "change:selectedAgents": "render",
    },
    ui: {
      snippet: "#snippetSearch",
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date", date);
      },
      getMonthlyDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:monthly", date);
      },
    },
    _createSnippetSelect: function () {
      this.ui.snippet
        .select2({
          placeholder: {
            id: 0,
            text: $.t("reports.placeholder.optional.snippet"),
          },
          allowClear: true,
          minimumInputLength: 1,
          ajax: {
            transport: function (params, success, failure) {
              const request = Messenger.reqres.request("snippets:typeahead", {
                query: params.data.term,
              });

              request.once("sync", (snippets) => {
                const results = snippets.map((snippet) => ({
                  id: snippet.get("id"),
                  text: snippet.get("text"),
                }));
                success({ results });
              });

              request.once("error", () => {
                failure();
              });

              return request;
            },
            processResults: _.identity,
            delay: 300,
            cache: true,
          },
        })
        .on("select2:select", (e) => {
          const selected = e.params.data;
          this.model.set("snippetId", selected.id);
          this.model.set("selectedSnippetName", selected.text);
          this.trigger("snippet:select", selected);
        })
        .on("select2:clear", () => {
          this.model.set("snippetId", null);
          this.model.set("selectedSnippetName", "");
        });
    },
    updateConfig: function () {
      const checked = this.getResponseStatusChecked();
      this.trigger("update:report:config", checked);
    },
    getAbbreviated: function () {
      return this.$el.find("#chkAbbreviated").prop("checked");
    },
    getStartDateFormatted: function () {
      return this.$el.find("#startDate").val();
    },
    getStartDateInMillis: function () {
      return this.model.get("startDate");
    },
    getEndDateFormatted: function () {
      return this.$el.find("#endDate").val();
    },
    getEndDateInMillis: function () {
      return this.model.get("endDate");
    },
    getReasonWithOrWithout: function () {
      return this.model.get("reasonWithOrWithout");
    },
    getBucket: function () {
      return this.model.get("bucket");
    },
    getReasonWithOrWithoutDisplay: function () {
      return this.model.get("reasonWithOrWithoutDisplay");
    },
    getSurveyChoice: function () {
      return this.model.get("surveyChoice");
    },
    getSurveyChoiceDisplay: function () {
      return this.model.get("surveyChoiceDisplay");
    },
    getEscalation: function () {
      return this.model.get("escalation");
    },
    getAgents: function () {
      const agentsSelected = this.$el.find("#agentChoices").val();
      if (agentsSelected === null || agentsSelected.length === 0) {
        return "";
      }
      return ReportUtilities.joinAgentParam(agentsSelected);
    },
    getAnalyticsTags: function () {
      const tagsSelected = this.$el.find(".analytics-tags").val();
      if (tagsSelected === null) {
        return "";
      }
      if (Array.isArray(tagsSelected)) {
        return tagsSelected.join("_");
      }
      return tagsSelected;
    },
    getArchivedTopicOption: function () {
      return this.$el.find("#archivedTopics").val();
    },
    getCategory: function () {
      return this.model.get("catVal");
    },
    getCategoryDisplay: function () {
      return this.model.get("catValDisplay");
    },
    getDocumentId: function () {
      return this.model.get("documentId");
    },
    getDocumentName: function () {
      return this.model.get("documentName");
    },
    getIncludeFinished: function () {
      return this.$el.find("#chkFinished").prop("checked");
    },
    getInterval: function () {
      return this.$el.find("#intervals").val();
    },
    getLanguages: function () {
      const languagesSelected = this.$el.find("#languageChoices").val();
      if (languagesSelected === null) {
        return "";
      }
      if (Array.isArray(languagesSelected)) {
        return languagesSelected.join("_");
      }
      return languagesSelected;
    },
    getMatchType: function () {
      return this.$el.find("#matchType").val();
    },
    getShowBlankResponses: function () {
      return this.$el.find("#chkShowBlankResponses").prop("checked");
    },
    getStatus: function () {
      return this.$el.find("#authoringStatus").val();
    },
    getSnippetId: function () {
      return this.model.get("snippetId");
    },
    getSnippetName: function () {
      return this.model.get("selectedSnippetName");
    },
    getTopic: function () {
      return this.model.get("topic");
    },
    getTopicName: function () {
      return this.model.get("selectedTopicName");
    },
    getTopicStatuses: function () {
      const topicStatusesSelected = this.$el.find("#topicStatusChoices").val();
      if (topicStatusesSelected === null) {
        return "";
      }
      if (Array.isArray(topicStatusesSelected)) {
        return topicStatusesSelected.join("_");
      }
      return topicStatusesSelected;
    },
    getTopicScheduledStatuses: function () {
      const topicScheduledStatusesSelected = this.$el.find("#topicScheduledStatusChoices").val();
      if (topicScheduledStatusesSelected === null) {
        return "";
      }
      if (Array.isArray(topicScheduledStatusesSelected)) {
        return topicScheduledStatusesSelected.join("_");
      }
      return topicScheduledStatusesSelected;
    },
    getResponseStatusChecked: function () {
      return this.$el.find("#showResponseStatusReport").prop("checked");
    },
    getTouchpoints: function () {
      const touchpointsSelected = this.$el.find("#touchpointChoices").val();
      if (touchpointsSelected === null) {
        return "";
      }
      if (Array.isArray(touchpointsSelected)) {
        return touchpointsSelected.join("_");
      }
      return touchpointsSelected;
    },
    getStandardResponse: function () {
      const standardResponseSelected = this.$el.find("#standardResponseChoice").val();
      if (standardResponseSelected === null) {
        return "";
      }
      return standardResponseSelected;
    },
    standardResponseChange: function (event) {
      this.model.set("selectedStandardResponse", event.target.value);
    },
    hide: function () {
      console.log("hiding configuration area");
      Messenger.vent.trigger("hide:configuration");
    },
    categoryChange: function (event) {
      this.model.set("selectedCategory", event.target.value);
      this.model.set("selectedCategoryValue", "");
      this.trigger("get:categories", event.target.value);
    },
    setCategoryValues: function (values) {
      this.model.set("categoryValues", values);
      this.render();
    },
    categoryValueChange: function () {
      //RD-999: Update this so it works in both Firefox and IE reliably
      this.model.set("catValDisplay", this.$el.find("#categoryValues option:selected").html());
      this.model.set("catVal", this.$el.find("#categoryValues option:selected").val());
    },
    touchpointClick: function (event) {
      this.model.set("selectedTouchpoint", event.target.value);
    },
    startDateClick: function () {
      const unixStart = this.$el.find("#startDate").datepicker("getDate").getTime();
      let date = new Date(this.model.setStartDate(unixStart));
      let format;
      if (this.model.get("limitToMonths")) {
        format = Messenger.reqres.request("get:moment:monthly:format");
      } else if (this.model.get("limitToYears")) {
        format = Messenger.reqres.request("get:moment:yearly:format");
      } else {
        format = Messenger.reqres.request("get:moment:date:format");
      }
      let displayDate = Moment(date.getTime()).format(format);
      this.$el.find("#startDate").datepicker("setDate", date);
      this.$el.find("#startDate").val(displayDate);
    },
    updateStartDatePicker: function (displayValue, datePickerObject) {
      console.log(displayValue);
      this.$el.find("#startDate").datepicker(datePickerObject);
      this.$el.find("#startDate").val(displayValue);
    },
    updateEndDatePicker: function (displayValue, datePickerObject) {
      console.log(displayValue);
      this.$el.find("#endDate").datepicker(datePickerObject);
      this.$el.find("#endDate").val(displayValue);
    },
    endDateClick: function () {
      const unixEnd = this.$el.find("#endDate").datepicker("getDate").getTime();
      let date = new Date(this.model.setEndDate(unixEnd));
      let format;
      if (this.model.get("limitToMonths")) {
        format = Messenger.reqres.request("get:moment:monthly:format");
      } else if (this.model.get("limitToYears")) {
        format = Messenger.reqres.request("get:moment:yearly:format");
      } else {
        format = Messenger.reqres.request("get:moment:date:format");
      }
      let displayDate = Moment(date.getTime()).format(format);
      this.$el.find("#endDate").datepicker("setDate", date);
      this.$el.find("#endDate").val(displayDate);
    },
    intervalClick: function (event) {
      Messenger.vent.trigger("report:updateInterval", event.target.value);
      if (this.model.get("limitToMonths") || this.model.get("limitToYears")) {
        this.$el.find("#startDate").prop("readonly", true);
        this.$el.find("#endDate").prop("readonly", true);
      } else {
        this.$el.find("#startDate").prop("readonly", false);
        this.$el.find("#endDate").prop("readonly", false);
      }
    },
    clickAll: function () {
      this.$el.find(".optionNotAll").each(function () {
        $(this).removeAttr("selected");
      });
    },
    clickNotAll: function () {
      this.$el.find(".optionAll").each(function () {
        $(this).removeAttr("selected");
      });
    },
    clickAbbreviated: function () {
      this.model.set("abbreviated", this.$el.find("#chkAbbreviated").prop("checked"));
    },
    clickFinished: function () {
      this.model.set("isFinished", this.$el.find("#chkFinished").prop("checked"));
    },
    printAll: async function () {
      //grab all charts and put 'em in one Portable Document
      //PS. This code is BAD NEWS because it directly refers to DOM elements outside of its own view.  This makes this
      // code directly dependent on the reportArea and singleReportModule, which defeats the whole purpose of
      // modularity.  We should instead reqres the reportArea module to get these objects from its own submodules.
      const array = [];
      let currentIdx = 0;

      const areas = ["west", "center", "east", "southwest", "south", "southeast"];
      for (let i = 0; i < areas.length; i++) {
        const highchartsCode = Messenger.reqres.request("report:area:highcharts:data", areas[i]);
        if (highchartsCode !== undefined) {
          array[currentIdx] = highchartsCode;
          currentIdx++;
        }
      }

      let filename = this.$el.find("#fileName").val();
      const fileType = this.$el.find("#printFormat option:selected").val().toLowerCase();
      if (filename.endsWith(fileType)) {
        filename = filename.substring(0, filename.length - 4);
      } else if (filename.endsWith(fileType.toUpperCase())) {
        filename = filename.substring(0, filename.length - 4);
      }
      let type = "";
      if (fileType === "pdf") {
        type = "application/pdf";
      } else if (fileType === "jpg") {
        type = "image/jpeg";
      } else if (fileType === "png") {
        type = "image/png";
      } else if (fileType === "svg") {
        type = "image/svg+xml";
      } else {
        console.error("Unexpected file type " + fileType);
        return;
      }
      //type should be something like 'application/pdf'
      await this.exportCharts(array, {
        type: type,
        filename: filename,
      });
    },
    /**
     * Create a global getSVG method that takes an array of charts as an argument
     */
    getSVG: async function (charts, exportOptions) {
      const svgExportOptions = {
        chart: {
          borderRadius: 0,
        },
        exporting: exportOptions,
      };
      if (charts.length === 1) {
        return await charts[0].exporting.getSVG(svgExportOptions, true);
      } else {
        let top = 0;
        let width = exportOptions.sourceWidth;
        const svgArray = await Promise.all(
          charts.map(async (chart) => {
            let svg = await chart.exporting.getSVG(svgExportOptions, true);
            svg = svg.replace("<svg", '<g transform="translate(0,' + top + ')" ');
            svg = svg.replace("</svg>", "</g>");

            top += chart.chartHeight;
            width = Math.max(width, chart.chartWidth);
            return svg;
          }),
        );
        return `<svg height="${top}" width="${width}" xmlns="http://www.w3.org/2000/svg">${svgArray.join("")}</svg>`;
      }
    },
    /**
     * Create a global exportCharts method that takes an array of charts as an argument,
     * and exporting options as the second argument
     */
    exportCharts: async function (charts, options) {
      if (!charts || !charts.length) {
        Messenger.okDialog($.t("reports.noChartsToSave"));
        return;
      }

      const width = charts
        .map((chart) => chart.chartWidth)
        .reduce((accumulator, chartWidth) => Math.max(accumulator, chartWidth), 600);

      // Merge export options with specific chart options
      const exportOptions = {
        ...Highcharts.getOptions().exporting,
        ...{
          sourceWidth: width,
        },
        ...options,
      };

      // Get the SVG for the charts and handle the response
      try {
        const svg = await this.getSVG(charts, exportOptions);
        if (!svg) {
          Messenger.okDialog($.t("reports.noChartsToSave"));
        } else {
          await charts[0].exporting.downloadSVG(svg, exportOptions);
        }
      } catch (e) {
        Messenger.okDialog($.t("reports.problemSavingCharts", { error: String(e) }));
      }
    },
    getDepartments: function () {
      const value = $(".departments", this.$el).val();
      if (Array.isArray(value)) {
        return value.join("_");
      }
      if (value) {
        return value;
      }
      return "";
    },
    getTaskChangeTypes: function () {
      const value = $(".task-change-types", this.$el).val();
      if (Array.isArray(value)) {
        return value.join("_");
      }
      if (value) {
        return value;
      }
      return "";
    },
    getTaskPriorities: function () {
      const value = $(".task-priorities", this.$el).val();
      if (Array.isArray(value)) {
        return value.join("_");
      }
      if (value) {
        return value;
      }
      return "";
    },
    getTaskOwners: function () {
      const value = $(".task-owners", this.$el).val();
      if (Array.isArray(value)) {
        return value.join("_");
      }
      if (value) {
        return value;
      }
      return "";
    },
    getTopicEditStatuses: function () {
      const value = $(".topic-edit-statuses", this.$el).val();
      if (Array.isArray(value)) {
        return value.join("_");
      }
      if (value) {
        return value;
      }
      return "";
    },
    getUsers: function () {
      const value = $(".users", this.$el).val();
      if (Array.isArray(value)) {
        return value.join("_");
      }
      if (value) {
        return value;
      }
      return "";
    },
    getTask: function () {
      return this.model.get("selectedTask");
    },
    getTaskName: function () {
      return this.model.get("selectedTaskName");
    },
    checkSearchEmpty: function () {
      const value = this.$el.find("#txtSearch").val();
      if (!value) {
        this.model.set("topic", null);
        this.model.set("selectedTopicName", "");
      }
    },
    checkTaskSearchEmpty: function () {
      const value = $(".task-search-input", this.$el).val();
      if (!value) {
        this.model.set("selectedTask", null);
        this.model.set("selectedTaskName", "");
      }
    },
  });

  return ConfigAreaView;
});
